<template>
  <div class="app-container">
    <div class="title-container">
      <div class="title-left">
        <div>兑换商品列表</div>
        <p>维护可用数字积分兑换的商品、价格、限购和上下架状态。</p>
      </div>
      <div class="title-right">
        数字积分兑换比例&nbsp;<el-input
          v-model="tbcCnyPrice"
          type="number"
          placeholder="请输入"
          style="width: 100px"
          @input="handleTbcCnyPriceInput"
        />&nbsp;人民币/1数字积分
        <el-button type="primary" class="comm_but_warp" @click="onUpdateTbcCnyPrice"
          >保存</el-button
        >
      </div>
    </div>

    <div class="filter-container">
      <el-input
        v-model="listQuery.keyword"
        placeholder="请输入关键字"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-select
        v-model="listQuery.type"
        placeholder="类型"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in PRODUCT_TYPE"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
      <el-select
        v-model="listQuery.tag"
        placeholder="商品标签"
        style="width: 140px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in goodsTagOptions"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
      <el-select
        v-model="listQuery.status"
        placeholder="状态"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in PRODUCT_STATUS"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
      <ShopOption
        :refValue="listQuery.shopId"
        class="filter-item"
        type="formShop"
        :styleRef="{ width: '200px' }"
        @valueFunc="getShopValueFunc"
      />
      <Category
        :value="listQuery.categoryId"
        @valueFunc="getCategoryValueFunc"
        type="queryCategory"
        :styleRef="{ width: '200px', marginRight: '10px' }"
        class="filter-item"
        :showLevels="false"
      />
      <el-select
        v-model="listQuery.deleted"
        placeholder="是否已删除"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in PRODUCT_IS_DELETE"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
      <DataPicker
        @valueFunc="getPickerValueFunc"
        paramsType="create"
        startPlaceholder="创建开始时间"
        endPlaceholder="创建截止时间"
      />
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter"
        >搜索</el-button
      >
      <el-button
        class="filter-item"
        type="primary"
        @click="checkDialogFormVisible(true, {}, 'CREATE')"
        >新增</el-button
      >
      <el-button
        class="filter-item"
        icon="el-icon-download"
        @click="handleExport"
        style="margin-left: 10px"
        >导出</el-button
      >
      <el-button
        class="filter-item"
        icon="el-icon-download"
        @click="handleExportTemplate"
        style="margin-left: 10px"
        >下载导入模版</el-button
      >
      <el-button
        class="filter-item"
        icon="el-icon-upload"
        @click="triggerFileInput"
        style="margin-left: 10px"
        >一键导入</el-button
      >
      <input
        ref="importFileInput"
        type="file"
        accept=".zip"
        style="display: none"
        @change="handleImport"
      />
    </div>

    <div
      style="
        margin-bottom: 5px;
        display: flex;
        align-items: center;
        justify-content: space-between;
      "
    >
      <div style="display: flex; align-items: center">
        <div>商品数量:{{ total }}</div>
        <el-button
          class="filter-item"
          v-if="listQuery.status === 0"
          type="primary"
          style="margin-left: 10px"
          icon="el-icon-s-operation"
          @click="handleBatchProcess('THROUGH')"
          >批量审核通过</el-button
        >

        <el-button
          class="filter-item"
          v-if="listQuery.status === 0"
          type="primary"
          style="margin-left: 10px"
          icon="el-icon-s-operation"
          @click="handleBatchProcess('REJECT')"
          >批量审核不通过</el-button
        >

        <el-button
          class="filter-item"
          v-if="listQuery.status === 1"
          type="primary"
          style="margin-left: 10px"
          icon="el-icon-s-operation"
          @click="handleBatchProcess('SHELVES')"
          >批量上架</el-button
        >

        <el-button
          class="filter-item"
          v-if="listQuery.status === 2"
          type="primary"
          style="margin-left: 10px"
          icon="el-icon-s-operation"
          @click="handleBatchProcess('OFFSHELVES')"
          >批量下架</el-button
        >
      </div>
      <el-button class="filter-item" type="primary" @click="onSyncData">同步</el-button>
    </div>

    <el-table
      ref="multipleTable"
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      size="small"
      border
      fit
      highlight-current-row
      row-key="id"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        width="55"
        v-if="listQuery.status === 0 || listQuery.status === 1 || listQuery.status === 2"
      />
      <el-table-column align="center" prop="id" label="ID" width="95"></el-table-column>
      <el-table-column label="商户名称" align="center" prop="mchName" width="100"></el-table-column>
      <el-table-column
        label="店铺名称"
        align="center"
        prop="shopName"
        width="100"
      ></el-table-column>
      <el-table-column
        label="品牌名称"
        align="center"
        prop="brandName"
        width="100"
      ></el-table-column>
      <el-table-column label="商品名称" align="left" prop="name" width="300"></el-table-column>
      <el-table-column label="原价" align="center" prop="adPrice"></el-table-column>
      <el-table-column label="供货价" align="center" prop="supplyPrice"></el-table-column>
      <el-table-column label="毛利率" align="center" prop="grossMargin">
        <template slot-scope="scope">
          <span>{{ scope.row.grossMargin }}%</span>
        </template>
      </el-table-column>
      <el-table-column label="规格现价" align="center" prop="supplyPrice">
        <template slot-scope="scope">
          <span>{{ scope.row.minPrice }}</span>
          <span v-if="scope.row.maxPrice">~{{ scope.row.maxPrice }}</span>
        </template>
      </el-table-column>
      <!--      <el-table-column-->
      <!--        label="最小价格"-->
      <!--        align="center"-->
      <!--        prop="minPrice"-->
      <!--      ></el-table-column>-->
      <!--      <el-table-column-->
      <!--        label="最大价格"-->
      <!--        align="center"-->
      <!--        prop="maxPrice"-->
      <!--      ></el-table-column>-->
      <el-table-column label="限购数量" align="center" prop="buyLimit"></el-table-column>
      <el-table-column label="主图地址" align="center" prop="mainGraph" width="200">
        <template slot-scope="scope">
          <el-image
            style="width: 100px; height: 100px"
            :src="scope.row.mainGraph"
            fit="cover"
          ></el-image>
        </template>
      </el-table-column>

      <el-table-column label="是否删除" align="center" prop="isDelete">
        <template slot-scope="scope">
          <el-tag :type="scope.row.isDelete ? 'danger' : 'info'">{{
            scope.row.isDelete ? "是" : "否"
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="类目名称" align="center" prop="caterotyName" width="200">
      </el-table-column>
      <el-table-column label="类型" align="center" prop="type">
        <template slot-scope="scope">
          {{ getValue(PRODUCT_TYPE, scope.row.type) }}
        </template>
      </el-table-column>
      <el-table-column label="商品标签" align="center" prop="tag" width="160">
        <template slot-scope="scope">
          {{ formatGoodsTags(scope.row.tag) }}
        </template>
      </el-table-column>

      <el-table-column label="赠送抵扣券抵扣金额" align="center" prop="buyDeduction">
        <template slot-scope="scope"> {{ scope.row.buyDeduction || 0 }}元 </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="状态" align="center">
        <template slot-scope="scope">
          <el-tag style="color: #ffffff" :color="getValue(PRODUCT_STATUS_CSS, scope.row.status)">{{
            getValue(PRODUCT_STATUS, scope.row.status)
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="ctdate" label="创建时间" width="180">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.ctdate) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="mddate" label="修改时间" width="180">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.mddate) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="280"
        fixed="right"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            type="warning"
            size="mini"
            @click="checkExamineVisible(true, scope.row)"
            class="comm_but_warp"
            v-if="scope.row.status === 0"
            >审核</el-button
          >
          <el-button
            type="primary"
            size="mini"
            @click="checkDialogFormVisible(true, scope.row, 'UPDATE')"
            class="comm_but_warp"
            v-if="!scope.row.isDelete"
            >编辑</el-button
          >
          <el-button
            type="success"
            plain
            size="mini"
            @click="upDownGoods(scope.row)"
            v-if="scope.row.status === 1"
            >上架</el-button
          >
          <el-button
            type="warning"
            size="mini"
            @click="upDownGoods(scope.row)"
            v-if="scope.row.status === 2"
            >下架</el-button
          >
          <el-button
            type="warning"
            plain
            size="mini"
            @click="jumpinfo(scope.row)"
            class="comm_but_warp"
            >预览</el-button
          >
          <el-button
            type="danger"
            size="mini"
            plain
            @click="deleteGoods(scope.row)"
            class="comm_but_warp"
            v-if="!scope.row.isDelete"
            >删除</el-button
          >
          <el-button
            type="success"
            size="mini"
            @click="deleteGoods(scope.row)"
            class="comm_but_warp"
            v-if="scope.row.isDelete"
            >恢复</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <!--    审核-->
    <el-dialog
      title="审核"
      :visible.sync="examineVisible"
      :close-on-click-modal="false"
      width="40%"
    >
      <el-form
        ref="examineForm"
        :rules="examineRules"
        :model="examineForm"
        label-position="left"
        label-width="150px"
        style="width: 80%; margin-left: 50px"
      >
        <el-form-item label="商户名称">
          <span>{{ examineObj.mchName }}</span>
        </el-form-item>
        <el-form-item label="店铺名称">
          <span>{{ examineObj.shopName }}</span>
        </el-form-item>
        <el-form-item label="品牌名称">
          <span>{{ examineObj.brandName }}</span>
        </el-form-item>
        <el-form-item label="类目名称">
          <span>{{ examineObj.caterotyName }}</span>
        </el-form-item>
        <el-form-item label="类型">
          <span>{{ getValue(PRODUCT_TYPE, examineObj.type) }}</span>
        </el-form-item>
        <el-form-item label="商品标签">
          <span> {{ formatGoodsTags(examineObj.tag) }}</span>
        </el-form-item>
        <el-form-item label="商品主图">
          <el-image
            style="width: 100px; height: 100px"
            :src="examineObj.mainGraph"
            fit="cover"
          ></el-image>
        </el-form-item>
        <el-form-item label="审核结果" prop="status">
          <el-select
            v-model="examineForm.status"
            placeholder="状态"
            style="width: 100%"
            class="filter-item"
            clearable
          >
            <el-option
              v-for="item in PRODUCT_EXAMINE_STATUS"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="checkExamineVisible(false, {})">取消</el-button>
        <el-button type="primary" @click="examineOk">确定</el-button>
      </div>
    </el-dialog>
    <!-- 同步确认弹框 -->
    <el-dialog
      width="50%"
      title="提示"
      v-loading="syncLoading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      :visible.sync="showSynchronous"
      append-to-body
    >
      <div>确认同步？</div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showSynchronous = false">取消</el-button>
        <el-button type="primary" @click="getSync">确定</el-button>
      </div>
    </el-dialog>
    <!-- 导入失败详情弹框 -->
    <el-dialog
      title="以下商品导入失败"
      :visible.sync="failDetailsVisible"
      :close-on-click-modal="false"
      width="40%"
    >
      <el-table :data="failDetails" style="width: 100%">
        <el-table-column prop="name" label="商品名称" width="200" />
        <el-table-column prop="reason" label="错误信息" />
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import {
  getGoodsList,
  checkGoods,
  upDownGoods,
  deleteGoods,
  exportGoodsList,
  syncGoodsSpecs,
  exportGoodsTemplate,
  importGoods,
  getTbcCnyPrice,
  updateTbcCnyPrice,
  getEnabledGoodsTagList
} from "@/api/product";
import { formatApiDate } from "@/utils/utils";
import { uploadXlsx } from "@/utils";
import { PRODUCT_STATUS_CSS } from "@/utils/enumUtileCss";
import {
  DIALOG_TITLE_TYPE,
  getValue,
  PRODUCT_EXAMINE_STATUS,
  PRODUCT_TYPE,
  PRODUCT_STATUS,
  PRODUCT_IS_DELETE,
  PRODUCT_TYPE_TAG
} from "@/utils/enumUtile";
import Category from "@/views/components/category.vue";
import ShopOption from "@/views/components/shopOption.vue";
import DataPicker from "@/views/components/dataPicker.vue";

export default {
  computed: {
    formatApiDate() {
      return formatApiDate;
    },
    DIALOG_TITLE_TYPE() {
      return DIALOG_TITLE_TYPE;
    },
    PRODUCT_EXAMINE_STATUS() {
      return PRODUCT_EXAMINE_STATUS;
    },
    PRODUCT_TYPE() {
      return PRODUCT_TYPE;
    },
    PRODUCT_STATUS() {
      return PRODUCT_STATUS;
    },
    PRODUCT_IS_DELETE() {
      return PRODUCT_IS_DELETE;
    },
    PRODUCT_STATUS_CSS() {
      return PRODUCT_STATUS_CSS;
    },
    PRODUCT_TYPE_TAG() {
      return PRODUCT_TYPE_TAG;
    }
  },
  components: { DataPicker, Category, ShopOption },
  filters: {},
  data() {
    return {
      selectedRows: [], // 存储用户选中的行数据
      showSynchronous: false,
      syncLoading: false,
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        pageSize: 20,
        keyword: null,
        type: null,
        tag: null,
        status: null,
        merchantId: null,
        shopId: null,
        brandId: null,
        categoryId: null,
        deleted: null,
        createStartTime: null,
        createEndTime: null
      },
      examineVisible: false, // 审核的弹框
      examineObj: {}, // 审核的弹框
      examineRules: {
        status: [{ required: true, message: "审核结果不能为空", trigger: "change" }]
      },
      examineForm: {
        id: 0, //
        status: null
      },
      failDetails: [],
      failDetailsVisible: false,
      goodsTagOptions: [],
      tbcCnyPrice: 0
    };
  },
  created() {
    console.log("判断是否是编辑进来", this.$route.query.isEdit);
    if (this.$route.query.isEdit) {
      this.listQuery = JSON.parse(sessionStorage.getItem("editObj"));
    }
    this.getEnabledGoodsTagList();
    this.getList();
    this.onTbcCnyPrice();
  },
  watch: {},
  methods: {
    getValue,
    getEnabledGoodsTagList() {
      getEnabledGoodsTagList().then(resp => {
        if (resp && resp.bizcode === 100) {
          this.goodsTagOptions = (resp.data && resp.data.entitys) || [];
        }
      });
    },
    parseGoodsTags(tag) {
      if (Array.isArray(tag)) {
        return tag.map(item => Number(item)).filter(Boolean);
      }
      if (tag === null || tag === undefined || tag === "" || tag === 0 || tag === "0") {
        return [];
      }
      if (tag === 1 || tag === "1") {
        return [2];
      }
      try {
        const parsed = JSON.parse(tag);
        return Array.isArray(parsed)
          ? parsed.map(item => Number(item)).filter(Boolean)
          : String(tag)
              .split(",")
              .map(item => Number(item))
              .filter(Boolean);
      } catch (e) {
        return String(tag)
          .split(",")
          .map(item => Number(item))
          .filter(Boolean);
      }
    },
    formatGoodsTags(tag) {
      const tagIds = this.parseGoodsTags(tag);
      if (tagIds.length === 0) {
        return "-";
      }
      return tagIds
        .map(id => {
          const found = this.goodsTagOptions.find(item => item.id === id);
          return found ? found.name : id;
        })
        .join("、");
    },
    // 查询TBC兑CNY价格
    onTbcCnyPrice() {
      getTbcCnyPrice().then(res => {
        if (res.bizcode === 100) {
          this.tbcCnyPrice = res.data || 0;
        }
      });
    },
    // 处理兑换比例输入
    handleTbcCnyPriceInput(val) {
      const num = parseFloat(val);
      if (isNaN(num) || num <= 0) {
        this.tbcCnyPrice = "";
      }
    },
    // 修改TBC兑CNY价格
    onUpdateTbcCnyPrice() {
      const num = parseFloat(this.tbcCnyPrice);
      if (isNaN(num) || num <= 0) {
        return this.$message.warning("请输入大于0的数字");
      }
      updateTbcCnyPrice({ price: this.tbcCnyPrice }).then(res => {
        if (res.bizcode === 100) {
          this.$message.success("修改成功");
          this.getTbcCnyPrice();
        }
      });
    },
    /** 同步 */
    getSync() {
      // 开始加载，设置loading为true
      this.syncLoading = true;

      syncGoodsSpecs()
        .then(() => {
          this.$message.success("同步成功");
          this.getList();
          // 关闭对话框
          this.showSynchronous = false;
        })
        .catch(error => {
          console.error("同步失败:", error);
          this.$message.error("同步失败，请稍后重试");
        })
        .finally(() => {
          // 无论成功失败，最终都关闭loading
          this.syncLoading = false;
        });
    },
    // 处理表格选中事件
    handleSelectionChange(selection) {
      this.selectedRows = selection;
      console.log("选中的行数据:", selection);
    },
    onSyncData() {
      this.showSynchronous = true;
    },
    // 批量处理
    handleBatchProcess(type) {
      if (this.selectedRows.length === 0) {
        this.$message.warning("当前筛选条件下没有选中商品");
        return;
      }

      // 获取选中的商品ID列表
      const selectedIds = this.selectedRows.map(item => item.id);
      console.log("获取选中的商品ID列表", selectedIds);

      if (type === "THROUGH") {
        // 待审核状态，批量审核通过
        this.batchExamineGoods(selectedIds, 1);
      } else if (type === "REJECT") {
        // 待审核状态，批量审核不通过
        this.batchExamineGoods(selectedIds, 3);
      } else if (type === "SHELVES") {
        // 未上架状态，默认批量上架
        this.batchUpDownGoods(selectedIds, 2);
      } else if (type === "OFFSHELVES") {
        // 已上架状态，默认批量下架
        this.batchUpDownGoods(selectedIds, 1);
      }
    },
    // 批量上下架商品方法
    batchUpDownGoods(ids, status) {
      this.$confirm(
        `确定要批量${status === 2 ? "上架" : "下架"}选中的 ${ids.length} 个商品吗？`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      ).then(() => {
        // 调用批量上下架接口,需要修改入参
        upDownGoods({ id: ids.join(","), status }).then(res => {
          if (res.bizcode == 100) {
            this.$message.success(`批量${status === 2 ? "上架" : "下架"}成功`);
            this.getList(); // 重新加载列表
            this.$refs.multipleTable.clearSelection(); // 清空选中状态
          }
        });
      });
    },
    // 批量审核商品方法
    batchExamineGoods(ids, status) {
      this.$confirm(
        `确定要批量${status === 1 ? "审核通过" : "审核不通过"}选中的 ${ids.length} 个商品吗？`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      ).then(async () => {
        checkGoods({ id: ids.join(","), status }).then(res => {
          if (res.bizcode == 100) {
            this.$message.success(`${status === 1 ? "审核通过" : "审核不通过"}成功`);
            this.getList(); // 重新加载列表
            this.$refs.multipleTable.clearSelection(); // 清空选中状态
          }
        });
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    /**
     * 查询列表
     */
    getList() {
      this.listLoading = true;
      const form = this.listQuery;
      console.log("列表查询参数", form);
      const params = {
        ...form,
        isBuyDeduction: 1
      };
      if (form.categoryId && form.categoryId.length !== 0) {
        params.categoryId = form.categoryId[form.categoryId.length - 1];
      }
      getGoodsList(params)
        .then(response => {
          this.list = response.data.entitys;
          this.total = response.data.totalCount;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    /**
     * 获取店铺
     * @param type
     * @param resultArr
     */
    getShopValueFunc(type, resultArr) {
      if (type === "formShop") {
        this.form.shopId = resultArr;
      }
    },
    /**
     * 切换状态
     * @param status
     * @param editObj
     * @param type
     */
    checkDialogFormVisible(status, editObj = {}, type) {
      if (type === "CREATE") {
        this.$router.push({ path: "/product/list/add" + "?isCoupon=1" });
      } else {
        sessionStorage.setItem("editObj", JSON.stringify(this.listQuery));
        this.$router.push({ path: "/product/list/edit/" + editObj.id + "?isCoupon=1" });
      }
    },

    // 审核 start
    checkExamineVisible(val, obj = {}) {
      this.examineObj = obj;
      if (obj && Object.keys(obj).length !== 0) {
        this.examineForm.id = obj.id;
      }
      this.examineVisible = val;
    },
    examineOk() {
      this.$refs["examineForm"].validate(valid => {
        if (valid) {
          const form = this.examineForm;
          const params = {
            ...form
          };
          checkGoods(params).then(() => {
            this.getList();
            this.checkExamineVisible(false);
            this.$notify({
              title: "成功",
              message: "审核成功",
              type: "success",
              duration: 2000
            });
          });
        }
      });
    },
    // 审核 end

    /**
     * 获取主营类目
     * @param type
     * @param resultArr
     */
    getCategoryValueFunc(type, resultArr) {
      if (type === "queryCategory") {
        this.listQuery.categoryId = resultArr;
      }
    },
    /**
     * 上下架商品
     * @param item
     */
    upDownGoods(item) {
      const params = {
        id: item.id,
        status: item.status === 1 ? 2 : 1
      };
      this.btnLoading = true;
      upDownGoods(params)
        .then(() => {
          this.getList();
          this.checkExamineVisible(false);
          this.$notify({
            title: "成功",
            message: item.status === 1 ? "上架" : "下架" + "成功",
            type: "success",
            duration: 2000
          });
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    /**
     * 删除商品
     * @param item
     */
    deleteGoods(item) {
      const deleteGoodsMsg = item.isDelete
        ? "确认要恢复该商品？"
        : "删除该商品后不可恢复，确认删除该商品？";
      this.$confirm(deleteGoodsMsg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        const params = {
          id: item.id,
          status: item.isDelete ? 2 : 1
        };
        this.btnLoading = true;
        deleteGoods(params)
          .then(() => {
            this.getList();
            this.$notify({
              title: "成功",
              message: "操作成功",
              type: "success",
              duration: 2000
            });
          })
          .finally(() => {
            this.btnLoading = false;
          });
      });
    },
    /**
     * 预览
     * @param item
     */
    jumpinfo(item) {
      this.$router.push({ path: "/product/list/info/" + item.id });
    },

    /**
     * 获取时间
     * @param type
     * @param value
     */
    getPickerValueFunc(type, value) {
      if (type === "create") {
        this.listQuery.createStartTime = value[0];
        this.listQuery.createEndTime = value[1];
      }
    },
    /**
     * 导出
     */
    handleExport() {
      const form = this.listQuery;
      const params = {
        ...form
      };
      exportGoodsList(params).then(response => {
        uploadXlsx(response, "商品表");
      });
    },

    /**
     * 导出模版
     */
    handleExportTemplate() {
      exportGoodsTemplate().then(response => {
        console.log(response);
        if (response.bizcode === 100) {
          const url = response && response.data;
          if (url) {
            window.open(url, "_blank");
          }
        }
      });
    },
    triggerFileInput() {
      this.$refs.importFileInput.click();
    },
    /**
     * 导入
     */
    handleImport(event) {
      const file = event.target.files[0];
      if (!file) {
        return;
      }
      if (file.type !== "application/zip" && !file.name.endsWith(".zip")) {
        this.$message.error("请上传zip格式文件");
        return;
      }
      this.$confirm(`确定要导入文件 ${file.name} 吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info"
      }).then(() => {
        this.listLoading = true;
        importGoods({ file })
          .then(response => {
            if (response.bizcode == 100) {
              console.log(response.data);

              if (response.data && response.data.fail) {
                console.log(response.data && response.data.failDetails);
                this.failDetails = (response.data && response.data.failDetails) || [];
                this.failDetailsVisible = true;
              } else {
                this.$message.success("导入成功");
              }
              this.getList();
            }
          })
          .finally(() => {
            this.listLoading = false;
            event.target.value = "";
          });
      });
    }
  }
};
</script>
<style scoped lang="scss">
.title-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;

  .title-left {
    font-size: 20px;
    font-weight: bold;

    p {
      font-size: 14px;
      color: #909399;
      margin-top: 5px;
      font-weight: normal;
    }
  }

  .title-right {
    font-size: 14px;
    color: #333;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
    border-radius: 5px;
    border: 1px solid rgb(116.4, 188.4, 255);
    padding: 3px 10px;
    background-color: rgb(231.9, 243.9, 255);
    font-weight: bold;

    .comm_but_warp {
      margin: 0 0 0 10px;
    }
  }
}

.el-dropdown-link {
  cursor: pointer;
  margin-left: 10px;
}

.comm_but_warp {
  margin-bottom: 10px;
}

.sync-button {
  display: flex;
  justify-items: center;
  align-items: center;
  width: 100px;
  height: 40px;
  border-radius: 5px;
  background-color: #3a8ee6;
  font-size: 14px;
  color: #fff;
}
</style>
